import { commitMutation } from "relay-runtime"
import {
  Ch_updateEpisodeOfCareInput,
  chEditEpisodeOfCareMutation,
} from "@/modules/patients/services/ch/__generated__/chEditEpisodeOfCareMutation.graphql"
import { chEditEpisodeOfCareMutation as chMutation } from "@/modules/patients/services/ch/chEditEpisodeOfCareMutation"
import {
  De_updateEpisodeOfCareInput,
  deEditEpisodeOfCareMutation,
} from "@/modules/patients/services/de/__generated__/deEditEpisodeOfCareMutation.graphql"
import { deEditEpisodeOfCareMutation as deMutation } from "@/modules/patients/services/de/deEditEpisodeOfCareMutation"
import { RelayEnvironment } from "@/relay-environment"
import { Country } from "@/types/__generated__/union-types"

export const editEpisodeOfCare = (
  country: Country,
  input: De_updateEpisodeOfCareInput & Ch_updateEpisodeOfCareInput,
  onCompleted?: () => void,
) => {
  const mutation = country === "CH" ? chMutation : deMutation

  commitMutation<chEditEpisodeOfCareMutation & deEditEpisodeOfCareMutation>(RelayEnvironment, {
    mutation,
    variables: { input },
    onCompleted,
  })
}
